import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ListedProductUnit } from 'contracts/ProductUnits';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_PRODUCTUNITS_',
  }
);

export interface ListProductUnitsState {
  data: ListedProductUnit[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListProductUnitsRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: ListedProductUnit[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListProductUnitsState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListProductUnitsState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ListProductUnitsState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ListProductUnitsState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListProductUnitsState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listProductUnits = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListProductUnitsTypes = Types;
export const ListProductUnitsActions = Creators;
